module.exports = __webpack_public_path__ + "img/3MCircularTT-Book.42d77072.svg";